module.exports = __webpack_public_path__ + "img/ring_g_c_0_1@3x.eb723e8f.png";